import { useEffectWithController } from '@carvana/merch-react-hooks';
import { isSuccess, isFailure } from '@carvana/merch-result';
import { useContext } from 'react';
import { MAX_RECENTLY_VIEWED_VEHICLES } from '~/constants/home';
import StaticContext from '~/context/common/StaticContext';
import { useIsLoggedIn } from '~/context/common/UserContext';
import { useGetIsReturnUser } from '~/context/home/GlobalContext';
import RecentVehiclesContext from '~/context/home/RecentVehiclesContext';
import fetchAnonymousRecentVehicles from '~/services/common/fetchAnonymousRecentVehicles';
import fetchAuthenticatedRecentVehicles from '~/services/common/fetchAuthenticatedRecentVehicles';
import { BrowserCookies } from '~/utilities';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetRecentVehicles() {
  const {
    recentVehiclesFromRcb: { setData, setLoaded, setLoading, setError },
    fetchRecentVehiclesTrigger
  } = useContext(RecentVehiclesContext);
  const { eventCorrelationId } = useContext(StaticContext);
  const isLoggedIn = useIsLoggedIn();
  const isReturningUser = useGetIsReturnUser();

  useEffectWithController(
    controller => {
      const browserCookieId = BrowserCookies.get('BrowserCookieId');

      if (!browserCookieId || !isReturningUser) {
        setLoaded();

        return;
      }

      setLoading();

      const fetcher = isLoggedIn
        ? fetchAuthenticatedRecentVehicles
        : fetchAnonymousRecentVehicles;

      fetcher(
        {
          browserCookieId,
          correlationId: eventCorrelationId,
          count: MAX_RECENTLY_VIEWED_VEHICLES
        },
        controller
      )
        .then(result => {
          if (isSuccess(result)) {
            setData(result.content.recentVehicles);

            return;
          }

          if (isFailure(result)) {
            setError(new Error(result.errorMessage));
          }

          setData([]);
        })
        .catch(
          generateErrorLogger(
            'Get recent vehicles',
            {},
            { callback: setError, controller }
          )
        );
    },
    [
      eventCorrelationId,
      fetchRecentVehiclesTrigger,
      isLoggedIn,
      isReturningUser,
      setData,
      setError,
      setLoaded,
      setLoading
    ]
  );
}
